import { useMemo, useRef } from "react";

function useNotifications(knock, feedId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var feedClientRef = useRef();
  return useMemo(() => {
    if (feedClientRef.current) feedClientRef.current.teardown();
    var feedClient = knock.feeds.initialize(feedId, options);
    feedClient.listenForUpdates();
    feedClientRef.current = feedClient;
    return feedClient;
  }, [knock, feedId, options.source, options.tenant, options.has_tenant, options.archived]);
}

export default useNotifications;
//# sourceMappingURL=useNotifications.js.map